import { render, staticRenderFns } from "./SingleExtraCharge.vue?vue&type=template&id=b9fddd8c"
import script from "./SingleExtraCharge.vue?vue&type=script&lang=js"
export * from "./SingleExtraCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports